import React from 'react';
import { View } from 'react-native';
import { Focusable } from '../Focusable';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export function Radio({ value, onChange, text, withBackground, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: [
            styles.container,
            text ? styles.containerWithText : {},
            withBackground
                ? value
                    ? styles.selectedContainerBackground
                    : styles.containerBackground
                : {},
            style
        ], onPress: () => {
            onChange(!value);
        } },
        React.createElement(View, { style: [
                styles.radioButtonContainer,
                value ? styles.selectedContainer : {}
            ] }, value ? React.createElement(View, { style: styles.middleDot }) : null),
        text ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: [
                styles.text,
                withBackground
                    ? value
                        ? styles.selectedText
                        : styles.invertedText
                    : {}
            ] }, text)) : null));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: { borderRadius: 999, flexDirection: 'row' },
    containerBackground: { backgroundColor: color.invert2.p4 },
    selectedContainerBackground: { backgroundColor: color.primary.ghost },
    containerWithText: { padding: size.C },
    radioButtonContainer: {
        height: size.J,
        width: size.J,
        borderRadius: 9999,
        borderWidth: 1,
        borderColor: color.invert2.p16,
        justifyContent: 'center',
        alignItems: 'center'
    },
    selectedContainer: {
        backgroundColor: color.primary.ghost,
        borderColor: color.primary.ghost
    },
    middleDot: {
        height: size.D,
        width: size.D,
        borderRadius: 9999,
        backgroundColor: color.primary.solid
    },
    text: { marginLeft: size.C, minWidth: size.N },
    invertedText: { color: color.invert2.p68 },
    selectedText: { color: color.primary.solid }
}));
//# sourceMappingURL=index.js.map